import React, { useState } from 'react';
import { XIcon, SettingsIcon, Trash2Icon, AlertTriangleIcon } from 'lucide-react';
import { InfoTab } from './InfoTab';
import { SpansTab } from './SpansTab';
import { EndGunTab } from './EndGunTab';
import { StyleTab } from './StyleTab';
import { WarningBanner } from './WarningBanner';
interface Span {
  id: number;
  diameter: string;
  length: string;
  quantity: number;
  hasWarning?: boolean;
  warningMessage?: string;
}
export function PivotPanel() {
  const [activeTab, setActiveTab] = useState('info');
  const [showWarning, setShowWarning] = useState(true);
  // Lift spans state to parent
  const [spans, setSpans] = useState<Span[]>([{
    id: 1,
    diameter: 'Elbow',
    length: '0.61',
    quantity: 1
  }, {
    id: 2,
    diameter: 'Spans 8"5/8',
    length: '50.14',
    quantity: 4
  }, {
    id: 3,
    diameter: 'Spans 6"5/8',
    length: '62.03',
    quantity: 2,
    hasWarning: true,
    warningMessage: 'Este tramo atraviesa un obstáculo detectado en el terreno'
  }, {
    id: 4,
    diameter: 'Spans 6"5/8',
    length: '56.08',
    quantity: 3
  }, {
    id: 5,
    diameter: 'OH 6"5/8',
    length: '15.50',
    quantity: 1
  }]);
  // Calculate total length from spans
  const totalLength = spans.reduce((sum, span) => sum + parseFloat(span.length) * span.quantity, 0);
  // Calculate area based on length (π * r²)
  const calculatedArea = Math.PI * Math.pow(totalLength, 2) / 10000; // Convert to hectares
  const handleAutoCalculate = () => {
    console.log('Auto-calculating spans...');
    setShowWarning(false);
  };
  const handleUpdateRadius = () => {
    console.log('Updating radius from spans...');
    setShowWarning(false);
  };
  const tabs = [{
    id: 'info',
    label: 'Info'
  }, {
    id: 'spans',
    label: 'Spans',
    hasWarning: true
  }, {
    id: 'endgun',
    label: 'End gun'
  }, {
    id: 'style',
    label: 'Style'
  }];
  return <div className="w-full max-w-md bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-154">
      {/* Warning Banner - shown when on Spans tab */}
      {activeTab === 'spans' && showWarning && <WarningBanner onClose={() => setShowWarning(false)} onAutoCalculate={handleAutoCalculate} onUpdateRadius={handleUpdateRadius} data-id="element-155" />}
      {/* Header with Close Button */}
      <div className="flex items-center justify-between p-5 border-b bg-gradient-to-r from-gray-50 to-white" data-id="element-156">
        <h2 className="text-xl font-bold text-gray-800" data-id="element-157">Edit Pivot</h2>
        <button className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-158">
          <XIcon className="w-5 h-5" data-id="element-159" />
        </button>
      </div>
      {/* Tabs */}
      <div className="flex border-b bg-gray-50" data-id="element-160">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 px-4 py-3 text-sm font-medium transition-all relative ${activeTab === tab.id ? 'text-blue-600 bg-white' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'}`} data-id="element-161">
            <span className="flex items-center justify-center gap-1" data-id="element-162">
              {tab.hasWarning && <AlertTriangleIcon className="w-4 h-4 text-red-500" data-id="element-163" />}
              {tab.label}
            </span>
            {activeTab === tab.id && <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-600 rounded-t" data-id="element-164" />}
          </button>)}
      </div>
      {/* Tab Content */}
      <div className="p-6 max-h-[600px] overflow-y-auto" data-id="element-165">
        {activeTab === 'info' && <InfoTab totalLength={totalLength} calculatedArea={calculatedArea} data-id="element-166" />}
        {activeTab === 'spans' && <SpansTab spans={spans} setSpans={setSpans} data-id="element-167" />}
        {activeTab === 'endgun' && <EndGunTab data-id="element-168" />}
        {activeTab === 'style' && <StyleTab data-id="element-169" />}
      </div>
      {/* Footer Actions */}
      <div className="px-6 pb-6 pt-4 border-t bg-gray-50 space-y-3" data-id="element-170">
        <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-colors" data-id="element-171">
          <SettingsIcon className="w-4 h-4" data-id="element-172" />
          <span data-id="element-173">View Machine Configuration</span>
        </button>
        <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-white hover:bg-red-50 text-red-600 border border-gray-300 rounded-lg font-medium transition-colors" data-id="element-174">
          <Trash2Icon className="w-4 h-4" data-id="element-175" />
          <span data-id="element-176">Delete Pivot</span>
        </button>
      </div>
    </div>;
}